import { useMutation } from "@tanstack/react-query";
import { SystemLicenses } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
const acknowledgeUsageWarning = async () => SystemLicenses.acknowledgeTrafficThreshold();
const useUsageWarningAcknowledgementMutation = () => {
  const acknowledge = useMutation({
    mutationFn: acknowledgeUsageWarning,
    onError: (errorThrown) => {
      UserNotification.error(
        `Acknowledging notification failed with status: ${errorThrown}`,
        "Could not acknowledge notification"
      );
    },
    onSuccess: () => {
      UserNotification.success("Notification has been successfully ackknowledged.", "Success!");
    }
  });
  return { acknowledgeNotifcation: acknowledge.mutateAsync };
};
export default useUsageWarningAcknowledgementMutation;
